import { type ClassValue, clsx } from 'clsx';
import { createTailwindMerge, getDefaultConfig, mergeConfigs } from 'tailwind-merge';

function generateArrayWithValues(sizes: string[]) {
    const values = ['100', '200', '300', '400', '500', '600', '700', '800', '900'];
    return sizes.map(size => ({ [size]: values }));
}

export function cn(...inputs: ClassValue[]) {
    const customTwMerge = createTailwindMerge(() =>
        mergeConfigs(getDefaultConfig(), {
            extend: {
                classGroups: {
                    text: [
                        // Add your custom class pattern
                        {
                            'text-headline': (() => generateArrayWithValues(['xl', 'lg', 'md', 'sm', 'xs']))(),
                        },
                        {
                            'text-title': (() => generateArrayWithValues(['xl', 'lg', 'md', 'sm', 'xs']))(),
                        },
                        {
                            'text-body': (() => generateArrayWithValues(['xl', 'lg', 'md', 'sm', 'xs']))(),
                        },
                        {
                            'text-button': (() => generateArrayWithValues(['xl', 'lg', 'md', 'sm', 'xs']))(),
                        },
                        {
                            'text-link': (() => generateArrayWithValues(['xl', 'lg', 'md', 'sm', 'xs']))(),
                        },
                        {
                            'text-trumpet': (() => generateArrayWithValues(['xl', 'lg', 'md', 'sm', 'xs']))(),
                        },
                        {
                            'text-number': (() => generateArrayWithValues(['xl', 'lg', 'md', 'sm', 'xs']))(),
                        },
                    ],
                },
            },
        }),
    );

    return customTwMerge(clsx(inputs));
}
